module.exports = {"SubTexture":[{"x":1,"y":1,"width":93,"name":"bubble_single/bubble_single","height":87}],"width":128,"name":"buble_single","imagePath":"buble_single_tex.png","height":128}


//////////////////
// WEBPACK FOOTER
// ./src/resource/buble_single/buble_single_tex.json
// module id = 365
// module chunks = 0